export default __webpack_public_path__ + "static/media/Magsaysay_LEWC2.3e5baa7d.png";